// The page-wide jQuery instance and its window globals.
//
// Imported FIRST by every entry that historically embedded jquery/src/jquery
// under webpack (BaseMain & the standalone Mains/print pages). Everything else
// — page entries using the bare global `$`, jQuery plugins, Twig-side
// consumers — picks the instance up from window, exactly as before; module
// execution order (Mains in <head> before page entries) guarantees it's set
// in time.
import $ from "jquery";

declare global {
  interface Window {
    jQuery: JQueryStatic;
    $: JQueryStatic;
  }
}

window.jQuery = $;
window.$ = $;

export default $;
